import { render, staticRenderFns } from "./ResultVote.vue?vue&type=template&id=b0ffbc6c&"
import script from "./ResultVote.vue?vue&type=script&lang=js&"
export * from "./ResultVote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports